<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/matriculas">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-autocomplete :disabled="!page.isNew" dense label="Ano letivo" v-model="dataset.data.year_id"
                                                required :items="dataset.years"
                                                :item-text="item => item.year + (item.default ? ' (Ano vigente)' : '')"
                                                item-value="id" outlined hide-details="auto">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <student-autocomplete
                                                v-model="dataset.data.student_id"
                                                :disabled="!page.isNew"
                                                :selected-items="dataset.students"
                                                label="Aluno"
                                                @selected="setSelectedStudent"
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="6">
                                            <v-autocomplete dense label="Turma" v-model="dataset.data.class_id" required
                                                :items="dataset.classes" item-text="name" item-value="id" outlined
                                                hide-details="auto">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Data da matrícula" type="date"
                                                v-model="dataset.data.date" required outlined hide-details="auto"
                                                :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-select dense label="Status" v-model="dataset.data.status"
                                                :items="dataset.statuses" item-text="text" item-value="value"
                                                outlined hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>

import axios from "axios"
import StudentAutocomplete from "@/layouts/components/StudentAutocomplete.vue"

export default {
    name: "SchoolEnrollmentDetails",
    components: {
        StudentAutocomplete,
    },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            studentLoading: false,
            data: {},
            students: [],
            statuses: [
                { text: "Ativa", value: "active" },
                { text: "Transferida", value: "transferred" },
                { text: "Cancelada", value: "cancelled" },
                { text: "Concluída", value: "completed" },
            ],
            years: [],
            classes: []
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
    }),


    created() {
        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/matriculas");
        },

        setSelectedStudent(student) {
            this.dataset.students = student ? [student] : [];
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.load();
            await this.loadYears();
            await this.loadClasses();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Nova matrícula' : 'Detalhes da matrícula'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Matrículas",
                disabled: false,
                to: "/matriculas",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/v1/school-enrollments/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = {
                    ...data,
                    date: data.enrollment_date || data.date,
                    status: data.status || "active",
                };

                this.dataset.students.push(this.dataset.data.student)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadYears() {

            try {
                const result = await axios.get(`/api/v1/school-years`);

                this.dataset.years = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadClasses() {

            try {
                const result = await axios.get(`/api/v1/classes`);

                this.dataset.classes = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir a matrícula?',
                title: 'Incluir matrícula',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/v1/school-enrollments', payload);

                this.$dialog.notify.info("Matrícula adicionada com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados da matrícula?',
                title: 'Atualizar matrícula',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v1/school-enrollments/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Matrícula atualizada com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },


        buildPayload() {
            const data = {
                year_id: this.dataset.data.year_id,
                class_id: this.dataset.data.class_id,
                student_id: this.dataset.data.student_id,
                date: this.dataset.data.date,
                status: this.dataset.data.status || "active",
            }

            return data;
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
